export enum TicketState {
    Start = 0,
    Running = 1,
    Closed = 2
}